import React from "react";
import SubPageLayout from "@/components/common/SubPageLayout";
import DiagramSection from "@/components/diagrams/DiagramSection";
import WedgeWireProfileDiagram from "@/components/diagrams/WedgeWireProfileDiagram";
import { useLanguage } from "@/hooks/useLanguage";
import { pick } from "@/lib/i18n";
import { COPY } from "./content";
const DIAGRAM_COPY = {
  en: {
    title: "Cylindrical Screen Construction & Radial Flow Geometry",
    lead: "Continuous surface profile wires resistance-welded to longitudinal support rods form a rigid cylindrical filter cage with non-clogging slots."
  },
  zh: {
    title: "圆柱筛管全焊结构与径向流体几何原理",
    lead: "连续表面异型丝全电阻熔焊于纵向支撑筋条外周，构成高强度抗压溃圆柱形滤笼与防堵通道。"
  },
  es: {
    title: "Construcción del Cilindro y Geometría de Flujo Radial",
    lead: "Alambres continuos soldados por resistencia a varillas longitudinales formando una jaula cilíndrica rígida anticolmatación."
  },
  de: {
    title: "Spaltrohr-Konstruktion & Radiale Strömungsgeometrie",
    lead: "Widerstandsgeschweißte Profil- und Tragstäbe bilden einen hochstabilen Zylinderkäfig mit verstopfungsfreien Spalten."
  },
  fr: {
    title: "Construction du Tube Filtrant et Écoulement Radial",
    lead: "Fils profilés soudés par résistance sur des tiges longitudinales créant une cage cylindrique rigide et autonettoyante."
  },
  pt: {
    title: "Construção do Cilindro e Geometria de Fluxo Radial",
    lead: "Arames contínuos soldados por fusão sobre barras longitudinais formando uma gaiola cilíndrica rígida antiobstrução."
  }
};
export default function ScreenTubesPage() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, COPY);
  const diagramCopy = pick(lang, DIAGRAM_COPY);
  const diagram = <DiagramSection id="screen-tubes-diagram" title={diagramCopy.title} lead={diagramCopy.lead} tone="muted">
      <div className="max-w-xl mx-auto">
        <WedgeWireProfileDiagram variant="cylinder" />
      </div>
    </DiagramSection>;
  return <SubPageLayout content={content} diagram={diagram} />;
}